import {constants} from "../../constants";

export const toggleImportBookModal = () => {
    return { type: constants.IMPORT_BOOK_MODAL_ACTION };
};
